export const AUTH_CONFIG_ROOT_KEY = 'patricia:config';
export const LOCALE_KEY = 'patricia:locale';
export const CART_KEY = 'cart:productList';
export const RECENT_PROPERTY_ID = 'recentPropertyId';
export const GUEST_TOKEN = 'guest_token';
